module.exports = __webpack_public_path__ + "img/00044.e4e70e37.webp";